<template>
  <div>
    <el-card>
      <div class="header-wrapper">
        <div class="left">
          <span class="title">管理后台</span>
        </div>
        <div class="right">
          <div class="home_con" @click="goBack"> <img class="img" src="@/assets/newsNotice/home.png" alt=""> 随手拍主页</div>
          <div class="userName">{{ userInfo.nickname }}</div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
// import apis from "@/apis/gzh.js";
// import { getToken } from "@/utils/cookie";
import api from "@/apis";
export default {
  name: "headerLogo",
  data() {
    return {
      userInfo: {}
    };
  },
  mounted() {
    this.userInfo = this.$store.state.userInfo
    // let token = getToken();
    // if (token) {
    //   this.getUserinfo();
    // } else {
    //   this.$bus.$on("processToken", res => {
    //     Promise.resolve(this.getHrToken(res)).then(() => {
    //       console.log(11111, res);
    //       this.getUserinfo();
    //       // this.userInfo.name = res.data.nickname;
    //     });
    //   });
    // }
   
  },
  methods: {
    getUserinfo() {
      api.getUserinfo().then(res => {
        this.userInfo = res.data;
      });
    },
    getHrToken(username) {
      return new Promise(resolve => {
        // console.log("username:" + new Date(), username);
        if (username) {
          let thisname = username;
          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }
        } else {
          // console.log("未登录");
          resolve();
        }
      });
    },
    goBack() {
      this.$router.replace('/photoCasually');
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-card {
  border-radius: 0;
  .el-card__body {
    padding: 0;
    height: 112px;
    display: flex;
    align-items: center;
    background-color: #f2fcf9;
  }
  .header-wrapper {
    flex: 1;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      margin-left: 90px;
      .logo {
        width: 223px;
        height: 44px;
        margin-right: 15px;
      }
      .title {
        font-size: 33px;
        font-weight: 600;
        margin-top: 5px;
      }
    }
    .right {
      display: flex;
      align-items: center;
      margin-right: 50px;
      .home_con{
        display: flex;
        align-items: center;
        margin-right: 100px;
        font-size: 27px;
        .img{
          width: 30px;
          height: 30px;
          margin-right: 5px;
        }
      }
      .rightImg {
        width: 30px;
        height: 30px;
      }
      .userName {
        font-size: 26px;
      }
      // .line {
      //   width: 1px;
      //   height: 30px;
      //   background-color: #e3e6f5;
      //   margin: 0 30px;
      // }
      .avatar-wrapper {
        width: 68px;
        height: 68px;
        line-height: 68px;
        .avatar {
          width: 68px;
          height: 68px;
          border-radius: 50%;
          margin-right: 10px;
        }
      }
      // .el-dropdown-link {
      //   font-size: 26px;
      // }
    }
  }
}
</style>
